import { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const res = await fetch(`${API}/api/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      setStatus("done");
      setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="mt-10 max-w-sm" data-testid="footer-newsletter">
      <p className="eyebrow mb-4 text-primary-foreground/50">Newsletter</p>
      {status === "done" ? (
        <p className="text-sm text-primary-foreground/80" data-testid="footer-newsletter-success">
          Thank you — you're on the list.
        </p>
      ) : (
        <form
          onSubmit={submit}
          className="flex items-center border-b border-white/20 pb-2"
          data-testid="footer-newsletter-form"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            data-testid="footer-newsletter-email"
            className="w-full bg-transparent text-sm text-primary-foreground placeholder:text-primary-foreground/40 focus:outline-none"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            data-testid="footer-newsletter-submit"
            className="ml-3 shrink-0 text-xs uppercase tracking-[0.16em] text-primary-foreground/70 transition-colors hover:text-primary-foreground disabled:opacity-50"
          >
            {status === "loading" ? "…" : "Subscribe →"}
          </button>
        </form>
      )}
      {status === "error" && (
        <p className="mt-2 text-xs text-red-300" data-testid="footer-newsletter-error">
          Something went wrong. Please try again.
        </p>
      )}
    </div>
  );
};
